import { Grid, Typography, useMediaQuery } from '@material-ui/core';
import React from 'react';
import { ROUTE_NAMES } from '../../Routes/Routes';
import { history } from '../../Routes/history';
import BaseButton from '../Buttons/BaseButton';
import { SlideUpTransition } from '../Transitions/Transitions';
import BaseDialog from './BaseDialog';

const redirect = () => history.push(ROUTE_NAMES.pqr);

const IndustrialPqrDialog = ({ open = true, onClose }) => {
  const isMobileSize = useMediaQuery(theme => theme.breakpoints.down('xs'));

  const content = () => (
    <Grid container>
      <Grid item xs={12}>
        <Typography variant="body1">
          <strong>
            Si desea realizar alguna modificación a su instalación de gas
            natural, Gases del Caribe le ofrece la posibilidad de acceder a los
            siguientes servicios, entre otros:
          </strong>
        </Typography>
        <ul>
          <li>
            <Typography>
              <strong>Reubicación de la tubería interna de gas natural:</strong>
            </Typography>
            <Typography>
              Debido a modificaciones en su vivienda, usted puede solicitar el
              cambio de lugar de la tubería interna de gas natural.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Solicitud de un punto adicional de consumo:</strong>
            </Typography>
            <Typography>
              Si usted necesita conectar otro artefacto a gas y/o gasodoméstico,
              puede solicitar un punto de consumo extra.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>Conexión de artefactos a gas y/o gasodomésticos:</strong>
            </Typography>
            <Typography>
              Gases del Caribe le instala fácilmente los artefactos a gas que
              usted solicite.
            </Typography>
          </li>
          <li>
            <Typography>
              <strong>
                Reubicación del centro de medición (medidores y componentes):
              </strong>
            </Typography>
            <Typography>
              Si realizaron modificaciones a su predio, puede solicitar el
              cambio de lugar del centro de medición.
            </Typography>
          </li>
        </ul>
      </Grid>
    </Grid>
  );

  const actions = () => (
    <Grid container justifyContent="space-between">
      <Grid item xs="auto">
        <BaseButton variant="outlined" onClick={onClose}>
          Cancelar
        </BaseButton>
      </Grid>
      <Grid item xs="auto">
        <BaseButton onClick={redirect}>Aceptar</BaseButton>
      </Grid>
    </Grid>
  );

  return (
    <BaseDialog
      open={open}
      handleClose={onClose}
      title="Información adicional"
      actions={actions}
      content={content}
      fullScreen={isMobileSize}
      contentSize="small"
      TransitionComponent={isMobileSize ? SlideUpTransition : undefined}
      disableBackdropClick={true}
    />
  );
};

export default IndustrialPqrDialog;
